import { Subject } from 'rxjs';

class SharedService {
  static cartChanged = new Subject();
  static productTypeChanged = new Subject();
}

export default SharedService;



// WEBPACK FOOTER //
// ./src/services/SharedService/index.js